/*
  Los logos son versiones en blanco con acentos de color: se leen sobre el
  fondo oscuro de la app y son ilegibles sobre blanco. Viven en
  frontend/public/marca/.

  Se usan a propósito en pocos lugares:
    - LogoMenu   -> barra superior
    - LogoLogin  -> tarjeta de inicio de sesión
    - LogoPie    -> pie de la pantalla de login
  El isotipo cuadrado solo se usa como favicon (ver index.html).
*/

interface Props {
  alto?: number;
  className?: string;
}

/// Alto natural de cada archivo, para reservar el ancho y que el encabezado
/// no salte mientras carga la imagen.
const PROPORCIONES = {
  menu: 628 / 163,
  login: 556 / 358,
  pie: 734 / 56,
} as const;

/// Logotipo horizontal. Va en la barra superior.
export function LogoMenu({ alto = 26, className = '' }: Props) {
  return (
    <img
      src="/marca/procom-menu.png"
      alt="Procom IT Solutions"
      height={alto}
      width={Math.round(alto * PROPORCIONES.menu)}
      style={{ height: alto, width: 'auto' }}
      className={`block ${className}`}
    />
  );
}

/// Logotipo apilado con el isotipo arriba. Va en la tarjeta de login.
export function LogoLogin({ alto = 96, className = '' }: Props) {
  return (
    <img
      src="/marca/procom-login.png"
      alt="Procom IT Solutions"
      height={alto}
      width={Math.round(alto * PROPORCIONES.login)}
      style={{ height: alto, width: 'auto' }}
      className={`block ${className}`}
    />
  );
}

/// Franja fina de marca. Va abajo a la izquierda en la pantalla de login.
export function LogoPie({ alto = 15, className = '' }: Props) {
  return (
    <img
      src="/marca/procom-pie.png"
      alt="Procom IT Solutions"
      height={alto}
      width={Math.round(alto * PROPORCIONES.pie)}
      style={{ height: alto, width: 'auto' }}
      className={`block ${className}`}
    />
  );
}
